// extracted by mini-css-extract-plugin
module.exports = {"page":"e_Ry","overview":"e_Sy","anchor":"e_Ty","breadcrumbs":"e_Uy","dealCta":"e_Vy","ethics":"e_Wy"};